<template>
  <notification-base :class="{ 'opacity-50': disabled }">
    <template #icon_start>
      <warning-icon class="w-6 h-6 text-[var(--disabled-color-light)]" />
    </template>
    <template #content>
      <slot name="content">
        <div class="text-th-light-gray font-light text-sm tracking-wide">
          <slot name="content_upper_row" />
        </div>
        <div class="text-th-secondary-gray">
          <slot name="content_lower_row" />
        </div>
      </slot>
    </template>
    <template v-if="canClick" #icon_end>
      <el-button
        text
        class="focus:outline-none focus:ring p-0"
        :disabled="disabled"
      >
        <el-icon class="th-flip text-2xl"><refresh-right-icon /></el-icon>
      </el-button>
    </template>
  </notification-base>
</template>

<script>
import NotificationBase from '../base'
import { RefreshRightIcon, WarningIcon } from '@shared/assets/icons'

export default {
  components: {
    NotificationBase,
    RefreshRightIcon,
    WarningIcon
  },
  props: {
    /**
     * canClick only tells the component if to render the button.
     * The actual click event should propagate to the parent and being triggered there
     */
    canClick: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.th-flip {
  transform: scale(-1, 1);
}
</style>
